import React from "react";
import performLogo from '../../../images/planful-perform-logo-v2-white.svg';
// import iconPatternOne from '../../../images/perform-2023-pattern1.svg';
// import iconPatternTwo from '../../../images/perform-2023-pattern2.svg';
// import { Parallax } from "react-scroll-parallax";

const Perform2023IntroSection = ({ data }) => {
    return (
        // <Parallax y={[0, 0]} speed={-10}>
            <div className="cp-perform2023Intro">
                <div className="cp-perform2023Intro__inner">
                    {/* <div className="l--absolute l-absoluteOne">
                        <img src={iconPatternOne} alt="" />
                    </div>
                    <div className="l--absolute l-absoluteTwo">
                        <img src={iconPatternTwo} alt="" />
                    </div> */}
                    <img src={performLogo} alt="Perform 2023" />
                    <div className="cp-perform2023Intro__top l--flex" data-aos="fade-up">
                        <div className="cp-perform2023Intro__top-left l--flex">
                            <div>
                                {data.perform23IntroSectionHeader &&
                                    <h2>{data.perform23IntroSectionHeader}</h2>
                                }
                                {data.perform23IntroSectionTeaser &&
                                    <div dangerouslySetInnerHTML={{ __html: data.perform23IntroSectionTeaser }} />
                                }
                            </div>
                            <div>
                                {data.perform23IntroSectionLocations &&
                                    <div className="cp-performLocations l--flex">
                                        {data.perform23IntroSectionLocations.map((mapLocations, index) => (
                                            <div className="cp-performLocations__location l--flex" key={index}>
                                                {mapLocations.icon &&
                                                    <img src={mapLocations.icon.sourceUrl} alt={mapLocations.icon.altText} />
                                                }
                                                <div>
                                                    {mapLocations.hotelLocation &&
                                                        <h3 dangerouslySetInnerHTML={{__html: mapLocations.hotelLocation}} />
                                                    }
                                                    {mapLocations.hotelName &&
                                                        <span>{mapLocations.hotelName}</span>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {data.perform23IntroSectionCta &&
                                    <div className="l-buttonWrap">
                                        <a href={data.perform23IntroSectionCta.url} target={data.perform23IntroSectionCta.target} className="l-button">{data.perform23IntroSectionCta.title}</a>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="cp-perform2023Intro__top-right">
                            {data.perform23IntroSectionImage &&
                                <img src={data.perform23IntroSectionImage.sourceUrl} alt={data.perform23IntroSectionImage.altText} />
                                // <GatsbyImage className="l--borderRadiusLarge" image={getImage(data.perform23IntroSectionImage.gatsbyImage)} alt={data.perform23IntroSectionImage.altText} />
                            }
                        </div>
                    </div>
                    {data.perform23IntroSectionBanner &&
                        <div className="cp-perform2023Intro__bottom" data-aos="fade-up">
                            <p dangerouslySetInnerHTML={{ __html: data.perform23IntroSectionBanner }} />
                        </div>
                    }
                </div>
            </div>
        // </Parallax>
    )
}
export default Perform2023IntroSection;

